// eslint-disable-next-line no-unused-vars
import React, { useContext } from "react";
import { AuthContext } from "../AuthContext";
function WaitForFirebase({ placeholder, children }) {
  const { authReady } = useContext(AuthContext);
  if (authReady) {
    return children;
  } else if (placeholder) {
    return placeholder;
  }
  return null;
}
export default WaitForFirebase;
